/*
 * Get expert profile info
 */
import { clientFetch } from '../clientFetch';

export const getDoctor = (personId, projectId = null, lat = undefined, lon = undefined) => {
  return clientFetch(`/entity/doctor/${personId}`, { params: { projectId, lat, lon } });
};
